import Link from 'next/link'
import Card from '../card/card'
import FlowbiteIconComponent, { IconType } from '../flowbite-icon/flowbiteIcon'
import React, { useEffect, useState } from 'react'

interface IProps {
  icon: IconType
  title: string
  items: { label: string; link?: string }[]
  className?: string
  previewCount?: number
}

const InfoCard = ({ icon, title, items, className, previewCount = 3 }: IProps) => {
  const [expanded, setExpanded] = useState(false)
  const [isSmallScreen, setIsSmallScreen] = useState(false)

  useEffect(() => {
    const checkScreen = () => setIsSmallScreen(window.innerWidth < 768)
    checkScreen()
    window.addEventListener('resize', checkScreen)
    return () => window.removeEventListener('resize', checkScreen)
  }, [])

  if (!items || items.length === 0) return null

  items = items.sort((a, b) => {
    if (!!a.link && !b.link) return -1
    if (!a.link && !!b.link) return 1
    return 0
  })

  const visibleItems = isSmallScreen && !expanded ? items.slice(0, previewCount) : items
  const hasMore = items.length > previewCount

  return (
    <Card className={`flex flex-col justify-start items-start py-2 pr-4   ${className}`}>
      <div className="flex w-full gap-1 min-w-0">
        <FlowbiteIconComponent iconType={icon} className="text-[#C13D20] shrink-0" />
        <div className="flex flex-col justify-start items-start grow min-w-0 w-full">
          <h1 className="text-sm md:text-md text-gray-600 w-full">{title}</h1>

          <div className="w-full flex flex-wrap">
            <span>
              {visibleItems.map((item, index) => (
                <React.Fragment key={item.label}>
                  {!!item.link ? (
                    <Link
                      href={item.link ?? ''}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline text-blue-500 min-w-0"
                      prefetch={false}
                    >
                      <span className="text-sm sm:text-lg font-bold break-words whitespace-normal">
                        {item.label}
                        {index !== visibleItems.length - 1 && (
                          <span className="text-gray-600 mr-1">, </span>
                        )}
                      </span>
                    </Link>
                  ) : (
                    <span className="text-sm sm:text-lg font-bold break-words whitespace-normal">
                      {item.label}
                      {index !== visibleItems.length - 1 && (
                        <span className="text-gray-600 mr-1">, </span>
                      )}
                    </span>
                  )}
                </React.Fragment>
              ))}
            </span>
            {hasMore && (
              <button
                onClick={() => setExpanded(!expanded)}
                className="text-sm md:hidden hover:underline font-light pt-2 flex items-center"
              >
                {expanded ? 'Show less' : 'Show more'}
                <FlowbiteIconComponent
                  className="text-gray-600 !ml-0"
                  iconClassName="stroke-[1.5]"
                  iconType={expanded ? 'ChevronUp' : 'ChevronDown'}
                />
              </button>
            )}
          </div>
        </div>
      </div>
    </Card>
  )
}

export default InfoCard
